module.exports = __webpack_public_path__ + "img/temp_icon.0303c3ec.svg";